import { render } from "./TableButtons.vue?vue&type=template&id=4dd1246f&scoped=true"
import script from "./TableButtons.vue?vue&type=script&lang=js"
export * from "./TableButtons.vue?vue&type=script&lang=js"

import "./TableButtons.vue?vue&type=style&index=0&id=4dd1246f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4dd1246f"

export default script